import React, { Component } from 'react';
import commonUtil from '../../../../utils/commonUtil';
import InputButton from '../../../../components/ZUILib/InputButton';

const channel = commonUtil.getChannel();
class EventWizardComponent extends Component {
  constructor(props) {
    super(props);
    this.totalStep = this.props.totalStep;
    this.getEventPosition = this.getEventPosition.bind(this);
  }

  getEventPosition() {
    const step = this.props.currentStep;
    const totalstep = this.totalStep;
    let position = '';
    if (step + 1 === totalstep) {
      position = 'last';
    } else if (step === 0) {
      position = 'first';
    } else {
      position = 'intrim';
    }
    return position;
  }
  render() {
    let buttonHtml;
    const position = this.getEventPosition();
    if (position === 'intrim') {
      buttonHtml = (
        <div className={channel === 'web' && `col-xs-12 ${this.props.currentStep != 2 && 'col-md-12'} mb-60 event-wizard-button-container step2ButtonsAlign ${this.props.currentStep == 2 && 'col-md-10 col-md-offset-1'}`}>
          {channel === 'web' ? 
              <div className="buttonBlock newButtonBlock step2ButtonsSectionWidth">
                {channel === 'web' ? <InputButton buttonAttr={this.props.prev} /> : <InputButton buttonAttr={{...this.props.prev,classname:'btnSecondaryAction size-Full'}} />}
                <InputButton id="one" buttonAttr={{...this.props.next,disabled:this.props.isDisabled ? 'disabled' : '',classname:`${this.props.isDisabled && 'disabledButton'}`}} />
              </div>
           :
              <div>
                <div className={"col-xs-6 col-sm-3 mb-60 step4LeftBtn"}>
                  <div className="buttonBlock newButtonBlock">
                    <InputButton buttonAttr={{...this.props.prev,classname:'btnSecondaryAction size-Full'}} />
                  </div>
                </div>
                <div className={'col-xs-6 col-sm-3 col-sm-offset-6 mb-60 step4RightBtn'}>
                  <div className="buttonBlock newButtonBlock">
                    <InputButton id="one" buttonAttr={{...this.props.next,disabled:this.props.isDisabled ? 'disabled' : '',classname:`${this.props.isDisabled && 'disabledButton'}`}} />
                  </div>
                </div>
              </div>
          }
        </div>
      );
    } else if (position === 'first') {
      buttonHtml = (
        <div className={channel === 'web' && 'col-xs-12 col-md-12 mb-60'}>
          <div className="buttonBlock newButtonBlock">
            {channel === 'web' ? <InputButton  buttonAttr={this.props.prev}/> : <InputButton buttonAttr={{...this.props.prev,classname:'btnSecondaryAction size-Full'}} />}
            <InputButton id="one" buttonAttr={{...this.props.next,
              disabled:this.props.isDisabled,
              classname:`${this.props.isDisabled && 'disabledButton'}`
              }} />
          </div>
        </div>
      );
    } else if (position === 'last') {
      buttonHtml = (
        <div>
          <div className={channel === 'web' ? "col-xs-12 col-sm-3 mb-60": "col-xs-6 col-sm-3 mb-60 step4LeftBtn"}>
            <div className="buttonBlock newButtonBlock">
              {channel === 'web' ? <InputButton  buttonAttr={this.props.prev} /> : <InputButton buttonAttr={{...this.props.prev,classname:'btnSecondaryAction size-Full'}} />}
            </div>
          </div>
          <div className={channel === 'web' ? 'col-xs-12 col-sm-3 col-sm-offset-6 mb-60' : 'col-xs-6 col-sm-3 col-sm-offset-6 mb-60 step4RightBtn'}>
            <div className="buttonBlock newButtonBlock">
              <InputButton buttonAttr={{
                ...this.props.submit,
                disabled:this.props.isDisabled ? true : '',
                classname:`${this.props.isDisabled && 'disabledButton'}`,
              }}/>
            </div>
          </div>
        </div>
      );
    }
    // change the HTML structure for the contract page
    return (
      <React.Fragment>
        {buttonHtml}
      </React.Fragment>
    );
  }
}

export default EventWizardComponent;
